module.exports = require("ramda/src/pluck");